export default __webpack_public_path__ + "static/media/Avenir-Light.d7d158a2.ttf";